import React, { useState } from "react";
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
import { AltSiteName, TeamBaseURL, ContactFormURL } from "../../utils";
// import { OfficeTeam } from "../../../queries/common_use_query";
import { ImageModule } from "../../common/Image_Module";
import Slider from "react-slick";
import "./Team.scss"
const settings1 = {
  dots: false,
  speed: 800,
  // slidesToShow: 1,
  // slidesToScroll: 1,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  arrows: false,
  mobileFirst: true,
  centerMode: false,
  responsive: [
    {
      breakpoint: 4000,
      settings: {
        arrows: false,
        slidesToShow: 4
      }
    },
    {
      breakpoint: 1199,
      settings: {
        arrows: false,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 500,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }
  ]
};
const Otherstaff = (props) => {
  // const {loading, error, data} = OfficeTeam(props.id);
  return (
    <React.Fragment>
      <section className="team-row otherstaff">
        
          <Container>
          {props.teams && props.teams.length > 0 && 
            <Row>
              <Col className="d-flex align-item-center team-banner">
                <div className="team-title">
                  <h2>Meet The Team</h2>
                </div>
                <div className="ms-auto">
                  <Link to="/about/meet-the-team/">
                  <button type="button" className="btn-circle">
                    <i className="icon-arrow"></i>
                  </button>
                  </Link>
                </div>
              </Col>
            </Row>
            }
            <div className="team-slider">
            {props.teams && props.teams.length > 0 && 
              <>
              <Slider className="banner-imgslider d-block" {...settings1}>
                {props.teams && props.teams.map((item, index) => {
                return<>
                <div className="team-item">
                  {/* <a href="javascript:;" className="img-zoom"> */}
                  <div className="img-zoom">
                    <ImageModule ImageSrc={item.Staff_Image} ggfx_results={item.ggfx_results} altText={item.Staff_Image.alternativeText ? item.Staff_Image.alternativeText : item.Name+' - '+item.Designation} strapi_id={item.id} imagename={"teams.Staff_Image.commontile"} />
                  {/* </a> */}
                  </div>
                  
                  {/* <Link to={`${TeamBaseURL}/${item.URL}`} > */}
                  <div className="team-block">
                        <span className="date-text">{item.Name}</span>
                        <span className="profile">{item.Designation}</span>
                  </div>
                  {/* </Link> */}
                  <Link to={`${ContactFormURL}?tid=${item.id}`} className="mail">Send an email</Link>
                  
                </div>
                </>
                })}
                
              </Slider>
              </>
            }

            </div>
          </Container>
        
      </section>

    </React.Fragment>
  )
}
export default Otherstaff
